/* ------------------------------daktela chat -------------------------------*/
var daktelaGuiConfig = {
    "server":"https://comfortclick.daktela.com/",
    "accessToken":"32577q2psp5n33p70pq05n965115r1sq"
};
// Create async script element
var daktelaWeb = null;
var daktelaScriptEl = document.createElement("script");
(function (attrs) { Object.keys(attrs).forEach(function (key) { daktelaScriptEl.setAttribute(key, attrs[key]); }); })
({"src":daktelaGuiConfig.server+"external/web/web.js", "type":"text/javascript", "async":true, "charset":"utf-8"});
daktelaScriptEl.onload = function() { if (typeof daktelaGui === 'undefined' || !daktelaGui) return; daktelaWeb = new daktelaGui(); daktelaWeb.init(daktelaGuiConfig); };
document.getElementsByTagName("head")[0].appendChild(daktelaScriptEl);

// Live chat Trigger 
document.addEventListener('DOMContentLoaded', () => {
    const liveChat = document.querySelectorAll('.live-chat__trigger');

    liveChat.forEach((item) => {
        item.addEventListener('click', () => {
            const chatButton = document.querySelector('.dw-button');
            console.log(chatButton, "liveChatchatButton");

            if (chatButton) {
                chatButton.click();
            } else {
                console.warn("Chat button not found");
            }
        });
    });
});
// Live chat Trigger for footer menu
document.addEventListener('DOMContentLoaded', () => {
    const liveChatText = [...document.querySelectorAll(
        '.custom-footer-menu .reversed-link__text'
    )].find(el => el.textContent.trim() === 'Live Chat');

    liveChatText?.closest('a')?.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('.dw-button')?.click();
    });
});